import React, { useState } from 'react'
import { Box, Grid, InputLabel } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import { Container, Page } from 'components'
import { Header, PhishingForm, ReportVersionTable } from './components'

import useSnackbar from 'hooks/useSnackbar'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import { schema } from './components/PhishingForm'

import useStyles from './styles'

const PhishingReport = () => {
  const [currentReportVersion, setCurrentReportVersion] = useState(null)
  const [exportingPdf, setExportingPdf] = useState(false)
  const [refresher, setRefresher] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      reportSelected: '',
      campaignId: null,
    },
  })

  const { triggerValidation, watch } = formMethods

  const { reportSelected, campaignId } = watch()

  const { phishing_campaign: phishingCampaign } = constants.reports.DESCRIPTION

  const handleRefresh = () => setRefresher((prev) => !prev)

  const buildReportParams = () => {
    const isGeneral = reportSelected === constants.phishing.REPORT_TYPES.GENERAL

    const phishingReport = {
      reportType: isGeneral ? 'general' : 'by_campaign',
    }

    if (!isGeneral) {
      phishingReport.phishingCampaignId = campaignId?.id
    }

    return { phishingReport }
  }

  const handleExportPdf = async () => {
    const isValid = await triggerValidation()
    if (!isValid) return

    try {
      setExportingPdf(true)

      await service.dponet.phishingCampaigns.generateReport(buildReportParams())

      snackbar.open({
        message: 'O relatório será gerado e enviado por e-mail!',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(
          error?.response?.data?.error ||
            'Houve um erro durante o processamento de dados.',
        ),
        variant: 'error',
      })
    } finally {
      setTimeout(handleRefresh, 5000)
      setExportingPdf(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <Page className={classes.root} title="Relatório de Phishing">
        <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
          <Box py={5}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Header
                  isLoading={exportingPdf}
                  buttonAction={handleExportPdf}
                  disabled={exportingPdf}
                  title={phishingCampaign.title}
                  description={phishingCampaign.content}
                  buttonType="button"
                />
              </Grid>
              <Grid item xs={12}>
                <InputLabel className={classes.label}>
                  Filtros de pesquisa:
                </InputLabel>
                <PhishingForm />
              </Grid>
              <Grid item xs={12}>
                <ReportVersionTable
                  currentReportVersion={currentReportVersion}
                  kind={constants.reportVersions.KIND.PHISHING}
                  refresher={refresher}
                  setCurrentReportVersion={setCurrentReportVersion}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Page>
    </FormContext>
  )
}

export default PhishingReport
